// extracted by mini-css-extract-plugin
module.exports = {"admin":"header-module--admin--20LxK","header":"header-module--header--1mgxU","headerContainer":"header-module--headerContainer--1zu0Q","logo":"header-module--logo--3Cvy3"};